export type ClickUpBugPriority = "urgent" | "high" | "normal" | "low";

export const CLICKUP_BUG_PRIORITIES: {
  value: ClickUpBugPriority;
  label: string;
}[] = [
  { value: "urgent", label: "Urgent" },
  { value: "high", label: "High" },
  { value: "normal", label: "Normal" },
  { value: "low", label: "Low" },
];

/** ClickUp priority flag colors for UI selects. */
export const CLICKUP_BUG_PRIORITY_META: Record<
  ClickUpBugPriority,
  { label: string; color: string }
> = {
  urgent: { label: "Urgent", color: "#F50000" },
  high: { label: "High", color: "#FFCC00" },
  normal: { label: "Normal", color: "#6FADC6" },
  low: { label: "Low", color: "#C4C4C4" },
};

export const CLICKUP_REPORTED_BY_OPTIONS = [
  "Mariam ElGhandour",
  "Habiba Mohamed",
  "Mohanad Yehia",
  "KODE IT Team",
  "KODE Sports Team",
  "KODE General",
  "RYZE IT Team",
  "RYZE Sports Team",
  "RYZE General",
  "O West IT Team",
  "O West Sports Team",
  "O West General",
  "Omar ElBana",
  "Kareem ElShaffei",
  "Dina Kishk",
] as const;

export const CLICKUP_BUG_SEVERITY_OPTIONS = [
  { value: "1", label: "1 — ❗" },
  { value: "2", label: "2 — ❗❗" },
  { value: "3", label: "3 — ❗❗❗" },
  { value: "4", label: "4 — ❗❗❗❗" },
  { value: "5", label: "5 — ❗❗❗❗❗" },
] as const;

/** Tags used on ClickUp Bugs list (901507469366), collected from workspace tasks. */
export const CLICKUP_BUG_TAG_OPTIONS = [
  "blocking",
  "done fe",
  "mohanad task",
  "msp",
  "not pending qa",
  "packages",
  "pending frontend",
  "pending integration",
  "pending paymob",
  "pending product",
  "pending qa",
  "prod bug",
  "ready for pr",
  "v2 bug",
] as const;

/** @deprecated Use CLICKUP_BUG_TAG_OPTIONS */
export const CLICKUP_BUG_TAG_SUGGESTIONS = CLICKUP_BUG_TAG_OPTIONS;

export interface ClickUpAssigneeOption {
  id: number;
  name: string;
  email: string;
}

/** ClickUp workspace members — used for the assignee select in the bug handoff form. */
export const CLICKUP_ASSIGNEE_OPTIONS: ClickUpAssigneeOption[] = [
  { id: 66025304, name: "A. Al-Gazzar", email: "mile44612@gmail.com" },
  { id: 88795933, name: "aabdelfattah@kodeclubs.com", email: "aabdelfattah@kodeclubs.com" },
  { id: 88776088, name: "Abdelrahman Saeed", email: "aayoub@ryzeclubs.com" },
  { id: 100789835, name: "Abdelrhman Nagy", email: "anagy@kodeclubs.com" },
  { id: 94722380, name: "Abdelsalam Abbas", email: "abdelsalam.naeim@gmail.com" },
  { id: 94743424, name: "Adam Nassar", email: "anassar@ryzeclubs.com" },
  { id: 106688621, name: "Ahmed Hamdy", email: "ahmed.hamdii.kamal@gmail.com" },
  { id: 82505610, name: "Ahmed Heidar", email: "ahmedsalahheidar@gmail.com" },
  { id: 66186290, name: "Ahmed Seif", email: "aseif@kodeclubs.com" },
  { id: 82522969, name: "Anas", email: "anassaddel@gmail.com" },
  { id: 152451042, name: "Anas Osama", email: "aoa@blueribbon-inc.com" },
  { id: 188684620, name: "Dina Kishk", email: "dkk@blueribbon-inc.com" },
  { id: 54242643, name: "Ezz Hassan", email: "eha@blueribbon-inc.com" },
  { id: 78098953, name: "Fadwa Hussien", email: "fhussien@kodeclubs.com" },
  { id: 100787722, name: "Fady Walid", email: "fsamaha@ryzeclubs.com" },
  { id: 200556078, name: "Fady walid", email: "fadywalid119@gmail.com" },
  { id: 88765938, name: "GAZZAR", email: "gazzar@kodeclubs.com" },
  { id: 100505387, name: "Habiba Mohamed", email: "habibamohamed55874@gmail.com" },
  { id: 100505388, name: "Jomana Tantawy", email: "jomanatantawy42@gmail.com" },
  { id: 158611170, name: "Joseph Marzouk", email: "joseph1marzok@gmail.com" },
  { id: 100567478, name: "Kamal Said", email: "kamal.said58@gmail.com" },
  { id: 88774416, name: "Kareem Elshafey", email: "kee@blueribbon-inc.com" },
  { id: 82508906, name: "Kareem Heidar", email: "kareemheidar@gmail.com" },
  { id: 218544284, name: "Khaled El sewedy", email: "kelsewedy@ryzeclubs.com" },
  { id: 82500698, name: "Khaled El Sewedy", email: "kelsewedy@kodeclubs.com" },
  { id: 94654440, name: "Khaled Farghaly", email: "kfk@blueribbon-inc.com" },
  { id: 88788737, name: "Mado", email: "mas@blueribbon-inc.com" },
  { id: 106528395, name: "Mahmoud Abdelsatar", email: "mabdelsatar@kodeclubs.com" },
  { id: 88740882, name: "Maisara Farahat", email: "mfa@blueribbon-inc.com" },
  { id: 88767493, name: "Mariam ElGhandour", email: "msg@blueribbon-inc.com" },
  { id: 88795934, name: "mfares@kodeclubs.com", email: "mfares@kodeclubs.com" },
  { id: 78098956, name: "Moahmed Abdelfattah", email: "mabdelfattah@kodeclubs.com" },
  { id: 100683314, name: "Mohamed Ali", email: "mmkandeelz74@gmail.com" },
  { id: 106688620, name: "Mohamed Ashraf", email: "muhamedabdelraheem22@gmail.com" },
  { id: 78098951, name: "Mohamed Fadaly", email: "mfadaly@kodeclubs.com" },
  { id: 88671765, name: "Mohamed Hesham", email: "mhesham@ryzeclubs.com" },
  { id: 54198116, name: "Mohamed Saada", email: "mms@blueribbon-inc.com" },
  { id: 88740573, name: "Mohamed Salama", email: "madooo98@gmail.com" },
  { id: 49262124, name: "mohamed sultan", email: "mohamed.sultan3235@gmail.com" },
  { id: 80497092, name: "Mohamed Yaser", email: "mohamedyaser1366@gmail.com" },
  { id: 54286241, name: "Mohamed Zohdy", email: "mzohdy@kodeclubs.com" },
  { id: 100505386, name: "Mohanad Yehia", email: "mohanned.3262@gmail.com" },
  { id: 93713317, name: "mostafa", email: "mahmed@klubkayan.com" },
  { id: 78037434, name: "Mostafa Nofal", email: "mmn@blueribbon-inc.com" },
  { id: 88775479, name: "Mukhtar ElFoly", email: "mme@blueribbon-inc.com" },
  { id: 54123437, name: "Murtaza Eliyas", email: "meliyas@pssolutions.me" },
  { id: 54123438, name: "Murtaza Hamza Ali", email: "mhamza@pssolutions.me" },
  { id: 87770544, name: "Nada Mohamed", email: "nmohamed@kodeclubs.com" },
  { id: 87777561, name: "nsherif@kodeclubs.com", email: "nsherif@kodeclubs.com" },
  { id: 100771700, name: "omar badr", email: "onaser@owestclub.com" },
  { id: 82700742, name: "Omar ElBana", email: "ohe@blueribbon-inc.com" },
  { id: 100537991, name: "Osama Adel", email: "oadel@owestclub.com" },
  { id: 82522968, name: "peter tawfik", email: "petertawfik9@gmail.com" },
  { id: 94508663, name: "pkhalifa@kodeclubs.com", email: "pkhalifa@kodeclubs.com" },
  { id: 87777560, name: "Reham Rasheed", email: "rrasheed@kodeclubs.com" },
  { id: 66273676, name: "Salma Mohamed", email: "smohamed@kodeclubs.com" },
  { id: 87770547, name: "Sara Seif", email: "sseif@kodeclubs.com" },
  { id: 88666875, name: "Sarah Amr", email: "sab@blueribbon-inc.com" },
  { id: 62554963, name: "Shaaban", email: "mohamed.elsayed.shabaan96@gmail.com" },
  { id: 188671018, name: "Shady Gamal", email: "sga@blueribbon-inc.com" },
  { id: 170477495, name: "Silvia Fahmy", email: "sfahmy@kodeclubs.com" },
  { id: 100683315, name: "Taiseer Darwish", email: "taiseerdarwish@gmail.com" },
  { id: 88726223, name: "Tarteel Elattar", email: "tae@blueribbon-inc.com" },
  { id: 88739331, name: "Unknown User (kf)", email: "khaledfarghaly011@gmail.com" },
  { id: 87777563, name: "yawad@kodeclubs.com", email: "yawad@kodeclubs.com" },
  { id: 82764888, name: "yousef sedeq", email: "ysedeq@kodeclubs.com" },
  { id: 80497095, name: "Youssef Belal", email: "youssef.belal.dawood@gmail.com" },
];

export function formatAssigneeLabel(assignee: ClickUpAssigneeOption): string {
  return `${assignee.name} — ${assignee.email}`;
}

export function getPersonInitials(name: string | undefined): string {
  const value = (name ?? "").trim();
  if (!value) {
    return "?";
  }

  const parts = value.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export function findAssigneeByEmail(
  email: string | undefined
): ClickUpAssigneeOption | undefined {
  const normalized = email?.trim().toLowerCase();
  if (!normalized) {
    return undefined;
  }

  return CLICKUP_ASSIGNEE_OPTIONS.find(
    (assignee) => assignee.email.toLowerCase() === normalized
  );
}

export function formatSeverityLabel(severity: string | undefined): string {
  const count = Number(severity);
  if (!Number.isFinite(count) || count < 1 || count > 5) {
    return severity?.trim() || "—";
  }

  return "❗".repeat(count);
}

export function parseTagsInput(tags: string | undefined): string[] {
  return (tags ?? "")
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean);
}

export function formatTagsInput(tags: string[]): string {
  return tags
    .map((tag) => tag.trim())
    .filter(Boolean)
    .join(", ");
}
